import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IEventLinkDTO } from '../../../../../api/event-links.dao';
import Text from '../../../../global/text/text';
import { DefaultClosePopoverButton } from '../../../../global/common-popover/default-close-popover-button';
import { CreateEventLinkType, EventLinksViewModel } from './event-links.viewmodel';
import { EventLinkFormViewModel } from './event-link-form/event-link-form.viewmodel';
import DefaultButton from '../../../../global/default-button/default-button';
import { EventLinkForm } from './event-link-form/event-link-form';
import { LABEL, URL } from '../../../../../modules/event-links/config';
import { CloseIcon } from '../../../../global/icons/icons';
import { REMOVE_TEXT, applyText, cancelText, editText } from '../../../../../constants/common-labels.constants';

type Props = {
    onDelete: () => void;
    vm: EventLinksViewModel;
} & IEventLinkDTO;

export const EventLinkItemInfoPopover = (
    props: Props
): JSX.Element => {
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

    const { vm, linkId, url, type, label } = props;

    const linkProps: IEventLinkDTO = {
        linkId: linkId,
        type: type,
        label: label,
        url: url
    };

    const formProps = {
        types: vm.linkTypes
    };
    const formVM = EventLinkFormViewModel.create(formProps, linkProps);

    const handleClick = e => {
        e.stopPropagation();
        setIsPopoverOpen(true);
    };

    const editForm = () => {
        const handleSubmit = () => {
            const link: CreateEventLinkType = {
                type: formVM.getLinkType(),
                label: formVM.getFieldByKey(LABEL).value as string,
                url: formVM.getFieldByKey(URL).value as string
            };
            if (!formVM.isVmValid()) {
                formVM.setVmTouched();
                return null;
            }
            vm.onEditEventLink(linkId, link, props);
        };

        return (
            <>
                <EventLinkForm vm={formVM} />
                <div className='oe-popup-layout__footer'>
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultClosePopoverButton
                            text={applyText()}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => handleSubmit()}
                        />
                        <DefaultClosePopoverButton
                            text={cancelText()}
                        />
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {isPopoverOpen ? editForm() :
                <>
                    <div className='oe-popup-layout__header'>
                        <DefaultClosePopoverButton
                            className='event-link__popover-close'
                            icon={CloseIcon}
                            modifier={['link']}
                            text=''
                        />
                    </div>
                    <div className='event-item-link__popover-body'>
                        <div className='event-item-link__info m-bottom-15px'>
                            <div className='event-item-link__info-title'>
                                <FormattedMessage id='oe.common.eventLinkType' defaultMessage='Link Type' />:
                            </div>
                            <div className='event-item-link__info-value'>
                                <Text tag='div' message={props.type} />
                            </div>
                        </div>
                        <div className='event-item-link__info m-bottom-15px'>
                            <div className='event-item-link__info-title'>
                                <FormattedMessage id='oe.common.eventLinkLabel' defaultMessage='Label' />:
                            </div>
                            <div className='event-item-link__info-value'>
                                <Text tag='div' message={props.label || props.type} />
                            </div>
                        </div>
                        <div className='event-item-link__info'>
                            <div className='event-item-link__info-title'>
                                <FormattedMessage id='oe.common.eventLinkUrl' defaultMessage='URL' />:
                            </div>
                            <div className='event-item-link__info-value'>
                                <Text tag='div' message={props.url} />
                            </div>
                        </div>
                        <DefaultButton
                            className='small-button m-bottom-15px m-top-15px'
                            text={editText()}
                            onClick={e => handleClick(e)}
                        />
                    </div>
                    {props.onDelete && (
                        <DefaultClosePopoverButton
                            text={<FormattedMessage {...REMOVE_TEXT} />}
                            modifier='link-warn'
                            className='popup-footer-remove-button event-item-link__remove-button'
                            onClick={props.onDelete}
                        />
                    )}
                </>
            }
        </>
    );
};
